export const APP_EVENTS = {
  HOME_READY: "ym:home-ready",
} as const;
